import { apiFetch } from "@/client/lib/api";
import type { StaffRole, TenantRole, UserKind } from "@/shared/types";

/** A single principal in the staff-wide user directory (`GET /users`). */
export interface AdminUser {
  id: string;
  email: string;
  name: string | null;
  kind: UserKind;
  tenantId: string | null;
  tenantRole: TenantRole | null;
  staffRole: StaffRole | null;
  status: string;
}

/** Staff-admin directory + staff role management (promote/demote). */
export const usersAdminApi = {
  list: () => apiFetch<{ users: AdminUser[] }>("/users"),
  setStaffRole: (id: string, staffRole: StaffRole) =>
    apiFetch<AdminUser>(`/users/${encodeURIComponent(id)}/staff-role`, {
      method: "PATCH",
      json: { staffRole },
    }),
};
